import React, { Component } from 'react'
import {
  Container,
  Grid,
  Header,
  Image
} from 'semantic-ui-react'
import {connect} from 'react-redux';

import {
    submitRequestResetPassword
} from '../../actions';
import FormsForgetPassword from '../../component/forms/forget_password';

class ForgetPasswordPage extends Component {
    componentDidMount() {
        if (this.props.userData) {
          this.props.history.push('/app');
        }
      }
    render() {
        return (
            <Container style={{ paddingTop: '2.5em' }}>

                <Image src="/groupcare_logo_hor.jpg" size="medium"/>

                <Header as='h2' block>
                    Reset Password
                </Header>

                <Grid centered columns={1}>
                    <Grid.Column>
                        <FormsForgetPassword
                            submitRequestResetPassword={this.props.submitRequestResetPassword}
                        />
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return { userData: state.user.user };
  }

export default connect(mapStateToProps, { submitRequestResetPassword })(ForgetPasswordPage);
